import {
  API_FAIL,
  API_SUCCESS,
  GET_CHARTS_DATA,
  GET_CHARTS_DATA_MESSAGE_STATUS,
  GET_CHARTS_DATA_MESSAGE_STATUS_FAIL,
  GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS,
  GET_LIST_BU_STORE_HEADER,
  GET_LIST_BU_STORE_HEADER_FAIL,
  GET_LIST_BU_STORE_HEADER_SUCCESS,
  GET_LIST_BU_TENANT_HEADER,
  GET_LIST_BU_TENANT_HEADER_FAIL,
  GET_LIST_BU_TENANT_HEADER_SUCCESS,
  GET_LIST_TENANT_HEADER,
  GET_LIST_TENANT_HEADER_FAIL,
  GET_LIST_TENANT_HEADER_SUCCESS,
  RESET_GET_LIST_BU_STORE_HEADER,
  RESET_GET_LIST_BU_TENANT_HEADER,
  RESET_SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_FAIL,
  SET_BU_STORE_HEADER_SUCCESS,
  SET_BU_TENANT_HEADER,
  SET_BU_TENANT_HEADER_FAIL,
  SET_BU_TENANT_HEADER_SUCCESS,
  SET_METHOD_SIGN_SUCCESS,
  SET_TENANT_CODE_HEADER,
} from "./actionTypes";

const INIT_STATE = {
  chartsData: [],
  //
  listTenant: [],
  loadingListTenant: false,
  tenantCodeHeader: null,
  //
  listBuOfTenant: [],
  buTenantHeader: null,
  buTenantHeaderInfo: null,
  //
  listBuStore: [],
  buStoreHeader: null,
  //
  finalBuInfo: null,
  finalBuReleaseInfo: null,
  finalListBuCode: [],
  //
  listMethodSign: [],
  listSignInfo: [],
  loadListMethodSign: false,
};

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CHARTS_DATA_MESSAGE_STATUS:
      return {
        ...state,
        loading: true,
        totalMessage: 0,
        listMessageWithStatus: {
          data: [],
        },
        chartsMLTDiep: {
          data: [],
        },
        chartMLTDiepInYear: {
          data: [],
        },
      };
    case GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        totalMessage: action.totalMessage,
        listMessageWithStatus: {
          data: action.listMessageWithStatus,
        },
        chartsMLTDiep: {
          data: action.chartsMLTDiep,
        },
        chartMLTDiepInYear: {
          data: action.chartMLTDiepInYear,
        },
      };
    case GET_CHARTS_DATA_MESSAGE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        totalMessage: 0,
        listMessageWithStatus: {
          data: [],
        },
        chartsMLTDiep: {
          data: [],
        },
        chartMLTDiepInYear: {
          data: [],
        },
        error: action.error,
      };
    case API_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsData: action.payload.data,
          };
        default:
          return state;
      }
    case API_FAIL:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsDataError: action.payload.error,
          };

        default:
          return state;
      }
    // GET_LIST_TENANT_HEADER
    case GET_LIST_TENANT_HEADER:
      return {
        ...state,
        loadingListTenant: true,
        listTenant: [],
      };
    case GET_LIST_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        loadingListTenant: false,
        listTenant: action.listTenant,
      };
    case GET_LIST_TENANT_HEADER_FAIL:
      return {
        ...state,
        loadingListTenant: false,
        listTenant: [],
        error: action.error,
      };
    //SET_TENANT_CODE_HEADER
    case SET_TENANT_CODE_HEADER:
      return {
        ...state,
        tenantCodeHeader: action.tenantCodeHeader,
      };
    //SET_BU_TENANT_HEADER
    case SET_BU_TENANT_HEADER:
      return {
        ...state,
        buTenantHeader: action.buTenantHeader,
        buTenantHeaderInfo: action.buTenantHeaderInfo,
        // loadListMethodSign: true,
        listMethodSign: [],
        listSignInfo: [],
      };
    case SET_BU_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        // loadListMethodSign: false,
        // listMethodSign: action.listMethodSign,
      };
    case SET_BU_TENANT_HEADER_FAIL:
      return {
        ...state,
        // loadListMethodSign: false,
        listMethodSign: [],
        listSignInfo: [],
      };
    // GET_LIST_BU_TENANT_HEADER
    case GET_LIST_BU_TENANT_HEADER:
      return {
        ...state,
        listBuOfTenant: [],
        listMethodSign: [],
        listSignInfo: [],
        type: action.type,
      };
    case GET_LIST_BU_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        listBuOfTenant: action.listBu,
        type: action.type,
      };

    case GET_LIST_BU_TENANT_HEADER_FAIL:
      return {
        ...state,
        listBuOfTenant: [],
        type: action.type,
      };
    case RESET_GET_LIST_BU_TENANT_HEADER:
      return {
        ...state,
        type: action.type,
      };

    // GET_LIST_BU_STORE_HEADER
    case GET_LIST_BU_STORE_HEADER:
      return {
        ...state,
        listBuStore: null,
        // listMethodSign: [],
        type: action.type,
      };
    case GET_LIST_BU_STORE_HEADER_SUCCESS:
      return {
        ...state,
        listBuStore: action.listBuStore,
        type: action.type,
      };
    case GET_LIST_BU_STORE_HEADER_FAIL:
      return {
        ...state,
        listBuStore: [],
        type: action.type,
      };
    case RESET_GET_LIST_BU_STORE_HEADER:
      return {
        ...state,
        type: action.type,
      };

    //SET_BU_STORE_HEADER
    case SET_BU_STORE_HEADER:
      return {
        ...state,
        buStoreHeader: action.buStoreHeader,
        loadListMethodSign: true,
        listMethodSign: [],
        listSignInfo: [],
        finalBuInfo: null,
        finalBuReleaseInfo: null,
        type: action.type,
      };
    case SET_BU_STORE_HEADER_SUCCESS:
      return {
        ...state,
        loadListMethodSign: false,
        listMethodSign: action.listMethodSign,
        listSignInfo: action.listSignInfo,
        buStoreHeader: action.bu_store_header,
        finalBuInfo: action.finalBuInfo,
        finalBuReleaseInfo: action.finalBuReleaseInfo,
        finalListBuCode: action.finalListBuCode,
        type: action.type,
      };
    case SET_BU_STORE_HEADER_FAIL:
      return {
        ...state,
        loadListMethodSign: false,
        listMethodSign: [],
        listSignInfo: [],
        buStoreHeader: null,
        finalBuInfo: null,
        finalBuReleaseInfo: null,
      };
    case RESET_SET_BU_STORE_HEADER:
      return {
        ...state,
        type: action.type,
      };
    case SET_METHOD_SIGN_SUCCESS:
      return {
        ...state,
        listMethodSign: action.listMethodSign,
      };
    default:
      return state;
  }
};

export default Dashboard;
